// Export Types
export const GET_LMSQUIZ_REQUEST = 'GET_LMSQUIZ_REQUEST';
export const GET_LMSQUIZ_SUCCESS = 'GET_LMSQUIZ_SUCCESS';
export const GET_LMSQUIZ_FAILURE = 'GET_LMSQUIZ_FAILURE';

export const RESET_LMSCOURSEMEMBER_REQUEST = 'RESET_LMSCOURSEMEMBER_REQUEST';
export const RESET_LMSCOURSEMEMBER_SUCCESS = 'RESET_LMSCOURSEMEMBER_SUCCESS';
export const RESET_LMSCOURSEMEMBER_FAILURE = 'RESET_LMSCOURSEMEMBER_FAILURE';
